import axiosClient from "./axiosClient";
import API_ENDPOINTS from "../constants/apiEndpoints";

function extractMessage(error, fallback) {
  const d = error?.response?.data;
  const inner = d?.data;
  return (
    inner?.reason ||
    inner?.message ||
    d?.reason ||
    d?.message ||
    error?.message ||
    fallback
  );
}

function unwrapArticleRows(response) {
  const envelope = response?.data?.data ?? response?.data ?? {};
  const rows = envelope?.data ?? envelope?.articles ?? [];
  return {
    rows: Array.isArray(rows) ? rows : [],
    message: envelope?.reason || envelope?.message || "Success",
    meta: {
      pointInTime: envelope?.point_in_time || null,
      statusCode: envelope?.status_code || response?.status,
    },
  };
}

/**
 * POST /articles/by-sub-category
 * FormData: category, sub_category, current_page, query_limit
 */
export async function fetchArticlesBySubCategory({
  category,
  subCategory,
  page = 1,
  limit = 12,
}) {
  if (!category?.trim() || !subCategory?.trim()) {
    return {
      status: false,
      message: "Missing category or subcategory.",
      data: [],
      meta: null,
    };
  }

  const formData = new FormData();
  formData.append("category", String(category).trim());
  formData.append("sub_category", String(subCategory).trim());
  formData.append("current_page", String(page));
  formData.append("query_limit", String(limit));

  try {
    const response = await axiosClient.post(API_ENDPOINTS.ARTICLES.BY_SUB_CATEGORY, formData, {
      headers: { "Content-Type": "multipart/form-data", Accept: "application/json" },
    });
    const { rows, message, meta } = unwrapArticleRows(response);
    return { status: true, message, data: rows, meta };
  } catch (error) {
    return {
      status: false,
      message: extractMessage(error, "Unable to load articles for this topic."),
      data: [],
      meta: null,
    };
  }
}
